import React, { useState } from "react";
import Box from "@mui/material/Box";
import FilterComponent from "../../../../ReusableFIlterComponent/FilterComponent";
import { useSelector, useDispatch } from "react-redux";
import {
  // setCreatedOnDate,
  setSelectedPriority,
  setSelectedCategory,
  setSelectedOwner,
  setLastUpdatedDate,
} from "../../../../../features/dataAccuracySlice";
import { selectAllUsers } from "../../../../../features/userSlice";

interface DataAccuracyFilterProps {
  clearSelectedDataAccuracy: any;
}

export default function DataAccuracyFilter({
  clearSelectedDataAccuracy,
}: DataAccuracyFilterProps) {
  const {
    selectedPriority,
    selectedCategory,
    lastUpdatedDate,
    selectedOwner,
    dataAccruracyData,
  } = useSelector((state: any) => state.dataAccuracy);
  const dispatch = useDispatch();

  const queryOutputs = dataAccruracyData?.query_output;
  const allUsers = useSelector(selectAllUsers);

  const [searchPriority, setSearchPriority] = useState("");
  const [searchCategory, setSearchCategory] = useState("");
  const [searchOwner, setSearchOwner] = useState("");

  const reconstructedUsers = allUsers
    .filter((item: any) => item.first_name && item.last_name)
    .map((u: any) => ({
      id: u.id,
      name: `${u.first_name || ""} ${u.last_name || ""}`.trim(),
      is_active: u.is_active,
      organization_id__name: u.organization_id__name,
      email: u.email,
    }));

  const filterConfig = [
    {
      key: "Priority",
      label: "Select Priority",
      searchTerm: searchPriority,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchPriority(e.target.value),
      selectedOption: selectedPriority,
      filterName: "priority",
      data: queryOutputs,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedPriority(updatedSelection)),
      count: selectedPriority && selectedPriority.length,
      colorSelected:
        selectedPriority !== null && selectedPriority.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "category",
      label: "Select Category",
      searchTerm: searchCategory,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchCategory(e.target.value),
      selectedOption: selectedCategory,
      filterName: "category",
      data: queryOutputs,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedCategory(updatedSelection)),
      count: selectedCategory && selectedCategory.length,
      colorSelected:
        selectedCategory !== null && selectedCategory.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "Last Updated",
      label: "Select Date",
      searchTerm: "",
      selectedOption: lastUpdatedDate,
      filterName: "last_updated",
      data: queryOutputs,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setLastUpdatedDate(updatedSelection)),
      count: lastUpdatedDate && lastUpdatedDate.length - 1,
      colorSelected:
        lastUpdatedDate !== null && lastUpdatedDate.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: false,
      isDateRangeFilter: true,
    },
    {
      key: "owner",
      label: "Select Owner",
      searchTerm: searchOwner,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchOwner(e.target.value),
      selectedOption: selectedOwner,
      filterName: "name",
      data: reconstructedUsers,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedOwner(updatedSelection)),
      count: selectedOwner && selectedOwner.length,
      colorSelected:
        selectedOwner !== null && selectedOwner.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
  ];

  const clearFilters = () => {
    dispatch(setSelectedPriority(null));
    dispatch(setSelectedCategory(null));
    dispatch(setLastUpdatedDate(null));
    dispatch(setSelectedOwner(null));
    clearSelectedDataAccuracy(null);
    setSearchPriority("");
    setSearchCategory("");
    setSearchOwner("");
  };

  return (
    <Box>
      <FilterComponent
        filterConfig={filterConfig}
        clearFilters={clearFilters}
      />
    </Box>
  );
}
